/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import React, { useEffect } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { CategoriesAPI } from "../../../api/Categories";
import { CategoriesAtom } from "../../../atoms/CategoriesAtom";
import { UserAtom } from "../../../atoms/UserAtom";
import CategoriesHeader from "./CategoriesHeader";
import CategoriesTable from "./CategoriesTable";

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export default function Categories(): JSX.Element | null {
  const [user] = useRecoilState(UserAtom);
  const setCategories = useSetRecoilState(CategoriesAtom);

  useEffect(() => {
    (async () => {
      const categoriesResponse = await CategoriesAPI.readAll();

      if (categoriesResponse) {
        setCategories(categoriesResponse);
      }
    })();
  }, []);

  if (!user) return null;

  return (
    <Container>
      <CategoriesHeader />

      <CategoriesTable />
    </Container>
  );
}
